module.exports = __webpack_public_path__ + "static/media/17.f5a871d9.jpg";